import createLucideIcon from '../createLucideIcon';

const ArrowDownFromLine = createLucideIcon('ArrowDownFromLine', [
  ['line', { x1: '12', x2: '12', y1: '21', y2: '7', key: '1ujnl2' }],
  ['polyline', { points: '6 15 12 21 18 15', key: 'd79o6v' }],
  ['path', { d: 'M19 3H5', key: '1236rx' }],
]);

export default ArrowDownFromLine;
